module.exports = __webpack_public_path__ + "img/yellow_line.03801270.png";